import React, {Component} from 'react';
import './apartment.scss';
import {
    Accordion,
    AccordionItem,
    AccordionItemButton,
    AccordionItemHeading,
    AccordionItemPanel
} from 'react-accessible-accordion';
import ReactTooltip from 'react-tooltip'
import {connect} from "react-redux";
import {withTranslate} from "react-redux-multilingual";
import {TbArrowUpRight} from 'react-icons/tb';
import Picture from "../../cpr/Picture";

class NeighborhoodsSection extends Component {
    json = []
    state = {
        isLoading: true
    }

    constructor(props) {
        super(props)
        this.load()
    }


    load = () => {
        const {translate} = this.props;

        fetch('/api/apartment-neighborhoods.json')
            .then((response) => response.json())
            .then((res) => {
                res.data.forEach((item, ind) => {
                    item.title = translate(item.title);
                });
                this.json = res;
                this.setState({isLoading: false})
            })
            .catch(reason => {
                console.log(reason)
            })
    }

    render() {
        const {translate} = this.props;

        return (
            <section className="cpr-section cpr-section--sunken cpr-neighborhoods" aria-labelledby="cpr-neighborhoods-title">
                <div className="cpr-container">
                    <h2 id="cpr-neighborhoods-title" className="cpr-h2 cpr-sentence cpr-neighborhoods__title">
                        {translate('neighborhoods')}
                    </h2>
                    {!this.state.isLoading ? (
                        <div className="cpr-neighborhoods__grid">
                            <ReactTooltip place="top" type="dark" effect="solid"/>
                            <div className="cpr-neighborhoods__map">
                                <Picture name="map" alt={translate('neighborhoods')}
                                         sizes="(min-width: 1024px) 66vw, 100vw"/>
                                {this.json.data.map((data, index) =>
                                    <span className="cpr-hotspot" key={index} style={data.position}
                                          data-tip={data.title} aria-hidden="true"/>
                                )}
                            </div>
                            <Accordion className="cpr-neighborhoods__list">
                                {this.json.data.map((data, index) =>
                                    <AccordionItem key={index}>
                                        <AccordionItemHeading>
                                            <AccordionItemButton>
                                                {data.title}
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel>
                                            <p>
                                                {data.desc === 'park_desc' ?
                                                    <>
                                                        {translate(data.desc)}
                                                    </> :
                                                    <a href={data.desc} target="_blank" rel="noopener noreferrer"
                                                       className="cpr-link">
                                                        {translate('more_info')}<TbArrowUpRight aria-hidden="true"/>
                                                    </a>
                                                }
                                            </p>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                )}
                            </Accordion>
                        </div>
                    ) : <div className="cpr-neighborhoods__skeleton" aria-hidden="true"/>}
                </div>
            </section>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        locale: state.Intl.locale
    }
};

export default connect(mapStateToProps)(withTranslate(NeighborhoodsSection));
